import Headroom from 'headroom.js'
import type { DirectiveBinding } from 'vue'

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.directive('headroom', {
    mounted(
      el,
      binding: DirectiveBinding<{
        offset?: number
        classes?: { initial?: string }
      }>,
    ) {
      el._headroom = new Headroom(el, {
        classes: {
          initial:
            binding.value?.classes?.initial || 'headroom headroom-page-header',
        },
        offset: binding.value?.offset || 120,
      })
      el._headroom.init()
    },
    updated(el, binding) {
      const oldOffset = binding.oldValue?.offset
      const offset = binding.value?.offset
      if (oldOffset === offset) return

      if (el._headroom) {
        try {
          el._headroom.destroy()
        } catch {
          // Silently fail
        }
      }
      el._headroom = new Headroom(el, {
        classes: {
          initial:
            binding.value?.classes?.initial || 'headroom headroom-page-header',
        },
        offset: offset || 120,
      })
      el._headroom.init()
    },
    getSSRProps() {
      return {}
    },
  })
})
